import {Task, TaskEvent} from "@core/model";
import {Theme} from "@emotion/react";
import {SxProps} from "@mui/material";
import {AppTheme} from "@theme";
import {translate} from "@util";
import {Messages} from "react-big-calendar";

const setCalendarVariables = (theme: AppTheme) => {
  const root = document.documentElement;
  root.style.setProperty("--rbc-paper", theme.palette.background.paper);
  root.style.setProperty("--rbc-border-radius", "12px");
  root.style.setProperty("--rbc-event-border-radius", "4px");
  root.style.setProperty("--rbc-today-bg", theme.colors.primaryContainer);
  root.style.setProperty("--rbc-event-bg", `${theme.palette.primary.main}`);
  root.style.setProperty(
    "--rbc-event-bg-hover",
    `${theme.palette.primary.dark}`,
  );
  root.style.setProperty(
    "--rbc-event-text-color",
    `${theme.palette.getContrastText(theme.palette.primary.main)}`,
  );

  root.style.setProperty(
    "--rbc-event-bg-selected",
    `${theme.palette.primary.main}`,
  );
  root.style.setProperty(
    "--rbc-event-border",
    `${theme.palette.primary.light}`,
  );
  root.style.setProperty(
    "--rbc-text-primary-color",
    theme.palette.text.primary,
  );
};

const unsetCalendarVariables = () => {
  const root = document.documentElement;
  root.style.removeProperty("--rbc-paper");
  root.style.removeProperty("--rbc-border-radius");
  root.style.removeProperty("--rbc-event-border-radius");
  root.style.removeProperty("--rbc-today-bg");
  root.style.removeProperty("--rbc-event-bg");
  root.style.removeProperty("--rbc-event-bg-hover");
  root.style.removeProperty("--rbc-event-bg-selected");
  root.style.removeProperty("--rbc-event-text-color");
  root.style.removeProperty("--rbc-event-border");
  root.style.removeProperty("--rbc-text-primary-color");
};

const getMessages = (): Messages<TaskEvent> => ({
  date: translate("calendar.date"),
  time: translate("calendar.time"),
  event: translate("calendar.event"),
  allDay: translate("calendar.allDay"),
  week: translate("calendar.week"),
  work_week: translate("calendar.work_week"),
  day: translate("calendar.day"),
  month: translate("calendar.month"),
  previous: translate("calendar.previous"),
  next: translate("calendar.next"),
  yesterday: translate("calendar.yesterday"),
  tomorrow: translate("calendar.tomorrow"),
  today: translate("calendar.today"),
  agenda: translate("calendar.agenda"),
  noEventsInRange: translate("calendar.noEventsInRange"),
  showMore: count => `+${count}`,
});

const convertTasks = (tasks: Task[]): TaskEvent[] =>
  tasks.map(t => ({
    id: t.id as string,
    title: t.name,
    description: t.description,
    start: new Date(t.start),
    end: new Date(t.end),
    status: t.status,
    recurring: t.recurring,
    assetId: t.assetId,
    userId: t.userId,
    assigneeId: t.assigneeId,
    tags: t.tags,
  }));

const truncateSx: SxProps<Theme> = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

export {
  getMessages,
  setCalendarVariables,
  unsetCalendarVariables,
  convertTasks,
  truncateSx,
};
